<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" mx-auto>
        <v-flex xs12 class="pa-2" v-if="config.ROLE_NAME === 'Director' || config.ROLE_NAME === 'Administrator' || config.ROLE_NAME === 'Operations Manager'">
          <v-layout row wrap>
            <!-- Graph view -->
            <v-flex xs12 v-if="lAction === 'view-operation-graph'">
              <v-flex class="text-right">
                <v-btn class="accent" @click="loadTableView()">More</v-btn>
              </v-flex>
              <v-flex xs12 v-for="(zone, i) in zones" :key="i">
                <v-card>
                  <v-card-title class="pa-1 primary--text orange lighten-4">
                    {{ zone.zone_name + ' [' + date + ']'}}
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 class="pa-4">
                        <v-card>
                          <v-card-title class="title">
                            <v-flex>
                              Attendance
                            </v-flex>
                          </v-card-title>
                          <v-layout row wrap class="text-center">
                            <v-flex xs12 sm6>
                              <div :id="'div_attPer_today_' + zone.zone_id">
                                <canvas :id="'chart_att_per_today_' + zone.zone_id"></canvas>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <div :id="'div_attPer_yest_' + zone.zone_id">
                                <canvas :id="'chart_att_per_yest_' + zone.zone_id"></canvas>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 sm6 class="pa-4">
                        <v-card>
                          <v-card-title class="title">
                            <v-flex>
                              Pending In/Out
                            </v-flex>
                          </v-card-title>
                          <v-layout row wrap class="text-center">
                            <v-flex xs12 sm6>
                              <div :id="'div_pend_today_' + zone.zone_id">
                                <canvas :id="'chart_pend_today_' + zone.zone_id"></canvas>
                              </div>
                            </v-flex>
                            <v-flex xs12 sm6>
                              <div :id="'div_pend_yest_' + zone.zone_id">
                                <canvas :id="'chart_pend_yest_' + zone.zone_id"></canvas>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-flex>
            <!-- table view -->
            <v-flex class="pa-0" v-if="lAction === 'view-operation' || lAction === 'view-operation-manager'">
              <v-card flat>
                <v-card-title class="px-0 py-2">
                  <v-layout row wrap>
                    <v-btn small icon @click="goBack()"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <v-flex xs6 class="pa-2">
                      <v-dialog ref="dlgDate"
                      persistent v-model="dlgDate"
                      max-width="290px"
                      :return-value.sync="lDate">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        slot="activator" label="Date"
                        v-model="lDate" append-icon="mdi-calendar-today"
                        readonly clearable
                        v-on="on"
                        hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="lDate"
                      first-day-of-week="1">
                      <v-spacer></v-spacer>
                      <v-btn text @click="dlgDate = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgDate.save(lDate)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs2 class="text-left ml-2">
                  <v-btn small fab class="accent" @click.native="loadAllDateByZone(lDate)">Go</v-btn>
                </v-flex>
                <v-flex xs12 sm3 :class="$vuetify.breakpoint.smAndDown ? 'text-right': 'text-right ml-10'">
                  <v-btn class="accent" @click="downloadAsPdf">Download As Pdf</v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
          <v-layout row wrap id="pdf_report">
            <v-flex xs12 sm4 v-for="(zone, i) in zones" :key="i" :id="i === 2 ? 'pageBreak' : ''">
              <v-card>
                <v-card-title class="pa-1 primary--text grey lighten-4">
                  {{ zone.zone_name + ' (' + zone.tot_site + ')' }}
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <div style="border-left: 1px solid black; border-bottom: 1px solid black;">
                        <v-data-table
                        :headers="header"
                        :items="metrics.filter(rec => rec.zone_id === zone.zone_id)"
                        hide-default-footer
                        disable-pagination
                        :mobile-breakpoint="0">
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td style="font-size: 11px; border-top: 1px solid black; border-right: 1px solid black;">{{ props.item.name }}</td>
                            <td style="font-size: 11px; border-top: 1px solid black; border-right: 1px solid black; cursor: pointer;"
                            v-for="(value, i) in props.item.values" :class="props.item.name === 'Attendance' ? value.value < '90%' ? 'red--text font-weight-black' : value.value > '98%' ? 'green--text font-weight-black' : 'orange--text font-weight-black' : ''"  @click="loadAllCommDetailsBasedOnZone(props.item.name, value)">
                            {{value.value}}
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</v-flex>

<!-- Field Officer View -->
<v-flex v-if="config.ROLE_NAME === 'Field Officer'">
  <v-card flat>
    <v-card-title class="px-0 py-2">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs5 sm2 class="pa-2 ml-2">
            <v-dialog ref="dlgFromDate"
            persistent v-model="dlgFromDate"
            max-width="290px"
            :return-value.sync="lDateFrom">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="From"
              v-model="lDateFrom" append-icon="mdi-calendar-today"
              readonly clearable
              v-on="on"
              hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="lDateFrom"
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text @click="dlgFromDate = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.dlgFromDate.save(lDateFrom)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs5 sm2 class="pa-2 ml-2">
        <v-dialog ref="dlgToDate"
        persistent v-model="dlgToDate"
        max-width="290px"
        :return-value.sync="lDateTo">
        <template v-slot:activator="{ on }">
          <v-text-field
          slot="activator" label="To"
          v-model="lDateTo" append-icon="mdi-calendar-today"
          readonly clearable
          v-on="on"
          hide-details
          ></v-text-field>
        </template>
        <v-date-picker v-model="lDateTo"
        first-day-of-week="1">
        <v-spacer></v-spacer>
        <v-btn text @click="dlgToDate = false">Cancel</v-btn>
        <v-btn text color="accent" @click="$refs.dlgToDate.save(lDateTo)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
  <v-flex xs6 sm2 :class="$vuetify.breakpoint.smAndDown ? 'ml-10' : ''">
    <v-text-field
    v-model="lField.percent"
    label="Minimum Percentage %"
    number
    hide-details
    outlined
    @input="minPercentage()"
    ></v-text-field>
  </v-flex>
  <v-flex xs4 sm2 class="text-left ml-2 mt-2">
    <v-btn small fab class="accent" @click.native="loadFieldOffice(lDateFrom, lDateTo)">Go</v-btn>
  </v-flex>
  <v-flex xs12 sm2 :class="$vuetify.breakpoint.smAndDown ? 'ml-10' : 'ml-15'">
    <v-checkbox
    v-model="lField.show_all_shifts"
    label="Show All Shift"
    hide-details
    class="shrink"
    @click="loadFieldOffice(lDateFrom, lDateTo, lField.show_all_shifts)"
    ></v-checkbox>
  </v-flex>
</v-layout>
</v-flex>
</v-card-title>
</v-card>
<v-layout row wrap>
  <v-flex xs12 sm3 v-for="(role, n) in roleList" :key="n">
    <v-card>
      <v-card-title class="pa-2 primary--text grey lighten-4" style="font-family: 'Verdana', cursive; font-size:20px; font-weight:bold">
        <span>{{ role }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small class="ma-0" @click="loadCommunityBasedOnMinPer(role, lField.show_all_shifts)"><v-icon>mdi-open-in-new</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-2">
        <v-layout row wrap class="subtitle-2 black--text">
          <v-flex xs12>
            <div class="red--text text-center lighten-2" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
              Total Absent
            </div>
            <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
              {{staffRoleCount[role].absent_percent + ' %'}}
            </div>
          </v-flex>
          <v-divider class="ma-1"></v-divider>
          <v-flex xs12>
            <div class="green--text text-center lighten-2" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
              Total Present
            </div>
            <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
              {{staffRoleCount[role].present_percent + ' %'}}
            </div>
          </v-flex>
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs6>
                <v-card flat class="grey lighten-4" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
                  <div class="blue--text text-center grey lighten-3">
                    Community
                  </div>
                  <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
                    {{staffRoleCount[role].total_community }}
                  </div>
                </v-card>
              </v-flex>
              <v-flex xs6>
                <v-card flat class="grey lighten-4" style="font-family: 'Verdana'; font-size:14px; font-weight:bold">
                  <div class="blue--text text-center grey lighten-3">
                    Absenties
                  </div>
                  <div class="text-center" style="font-family: 'Satisfy'; font-size:24px; font-weight:bold" v-if="staffRoleCount[role]">
                    {{staffRoleCount[role].total_absent }}
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-flex>
</v-layout>
</v-flex>

<!-- Attendance -->
<v-dialog v-model="showAttendance" persistent scrollable max-width="1000px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showAttendance = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="attHead"
      :items="attendance"
      fixed-header
      :search="search"
      :height="attendance.length > 5 ? '450' : attendance.length * 100"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadAttDetBasedOnComm(props.item)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.percentage }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="attHead"
      :items="attendance"
      title="Attendance Percentage Based On Community Wise"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- View Staff details -->
<v-dialog v-model="showAttDet" persistent scrollable max-width="1100px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <v-flex>
        {{ attCommTitle + (attCommDate ? ' [' + attCommDate + ']' : '')}}
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex class="pl-10 mb-2 text-right">
        <v-radio-group
        v-model="lAttData.showAllShifts"
        hide-details
        :mandatory="false"
        row
        @change="loadAllShift(lAttData, selectedRole, lAttData.showAllShifts)"
        >
        <v-radio label="Show All Shift" value="All"></v-radio>
        <v-radio label="Show Shift Wise" value="Shift"></v-radio>
      </v-radio-group>
    </v-flex>
    <v-btn small icon @click="CloseAtt()"><v-icon>mdi-close</v-icon></v-btn>
  </v-card-title>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="attDetHead"
    :items="attDet"
    fixed-header
    height="450"
    :search="search"
    hide-default-footer
    disable-pagination
    :mobile-breakpoint="0">
    <template slot="item" slot-scope="props">
      <tr :class="!props.item.attendance ? 'red--text' : ''">
        <td>{{ props.index + 1 }}</td>
        <td>{{ props.item.staff_name }}</td>
        <td>{{ props.item.staff_role }}</td>
        <td>{{ props.item.shift_abbr }}</td>
        <td>{{ props.item.start_time }}</td>
        <td>{{ props.item.end_time }}</td>
        <td>{{ props.item.attendance ? props.item.attendance : 'pending' }}</td>
        <td>{{ props.item.check_in ? handy.formatDBDateTime(props.item.check_in): '-' }}</td>
        <td>{{ props.item.check_out ? handy.formatDBDateTime(props.item.check_out): '-' }}</td>
        <td>{{ props.item.work_hours ? props.item.work_hours : '-' }}</td>
        <td>{{ props.item.emp_name ? props.item.emp_name : props.item.sby_temp_staff_name ? props.item.sby_temp_staff_name : '-' }}</td>
      </tr>
    </template>
  </v-data-table>
</div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="attDetHead"
      :items="attDet"
      title="Attendance Details"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- Pending In/Out -->
<v-dialog v-model="showPendingInOut" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showPendingInOut = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="pendHead"
      :items="pendingInAndOut"
      fixed-header
      :height="pendingInAndOut.length === 0 ? '' : pendingInAndOut.length > 5 ? '450' : pendingInAndOut.length * 100"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadPenByComm(props.item)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.pendingInandOut }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="pendHead"
      :items="pendingInAndOut"
      title="Pending In/Out Based On Community Wise"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- View pending In and out staff details -->
<v-dialog v-model="showPenDet" persistent scrollable max-width="800px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ this.penCommTitle + ' [' + this.penCommDate + ']'}}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showPenDet = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="penDetHead"
      :items="penDetComm"
      fixed-header
      height="450"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.staff_name }}</td>
          <td>{{ props.item.penInOut }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="penDetHead"
      :items="penDetComm"
      title="Pending In/Out Details"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- manual In/Out -->
<v-dialog v-model="showManualInOut" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showManualInOut = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="manualHead"
      :items="manualInAndOut"
      fixed-header
      :height="manualInAndOut.length === 0 ? '' : manualInAndOut.length > 5 ? '450' : manualInAndOut.length * 100"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadManualByComm(props.item)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.manualInandOut }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="manualHead"
      :items="manualInAndOut"
      title="Manual In/Out Based On Community"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- View manual In and out staff details -->
<v-dialog v-model="showManualDet" persistent scrollable max-width="800px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ this.manCommTitle + ' [' + this.manCommDate + ']'}}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showManualDet = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="manualDetHead"
      :items="manualDetComm"
      fixed-header
      height="450"
      :search="search"
      hide-default-footer
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.staff_name }}</td>
          <td>{{ props.item.manInOut }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="manualDetHead"
      :items="manualDetComm"
      title="Manual In/Out Details"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- total report/approved/submitted -->
<v-dialog v-model="showTotRepAppSub" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 px-3 py-4">
      <v-flex xs4>
        {{ zone.zone_name}}<br />
        <span class="subtitle-2">{{' [' + zone.date + ']' }}</span>
      </v-flex>
      <v-flex xs7 class="pl-5">
        <v-layout row wrap>
          <v-flex xs5 class="pa-0">
            <v-dialog ref="repFromDate"
            persistent v-model="repFromDate"
            max-width="290px"
            :return-value.sync="repDateFrom">
            <template v-slot:activator="{ on }">
              <v-text-field
              slot="activator" label="From"
              v-model="repDateFrom" append-icon="mdi-calendar-today"
              readonly clearable
              v-on="on"
              hide-details
              ></v-text-field>
            </template>
            <v-date-picker v-model="repDateFrom"
            first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text @click="repFromDate = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.repFromDate.save(repDateFrom)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex xs5 class="pl-1">
        <v-dialog ref="repToDate"
        persistent v-model="repToDate"
        max-width="290px"
        :return-value.sync="repDateTo">
        <template v-slot:activator="{ on }">
          <v-text-field
          slot="activator" label="To"
          v-model="repDateTo" append-icon="mdi-calendar-today"
          readonly clearable
          v-on="on"
          hide-details
          ></v-text-field>
        </template>
        <v-date-picker v-model="repDateTo"
        first-day-of-week="1">
        <v-spacer></v-spacer>
        <v-btn text @click="repToDate = false">Cancel</v-btn>
        <v-btn text color="accent" @click="$refs.repToDate.save(repDateTo)">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-flex>
  <v-flex xs1 class="text-right ml-2 mt-2">
    <v-btn small fab class="accent" @click="loadTotRepAppSubByCommBasedOnZone(zone, null, repDateFrom, repDateTo)">Go</v-btn>
  </v-flex>
</v-layout>
</v-flex>
<v-flex xs1 class="text-right">
  <v-btn small icon @click.stop="showTotRepAppSub = false"><v-icon>mdi-close</v-icon></v-btn>
</v-flex>
</v-card-title>
<v-card-text class="pa-0">
  <v-data-table
  :headers="totRepHead"
  :items="totRepAppSub"
  fixed-header
  :height="totRepAppSub.length > 5 ? '450' : totRepAppSub.length * 100"
  :search="search"
  hide-default-footer
  disable-pagination
  :mobile-breakpoint="0">
  <template slot="item" slot-scope="props">
    <tr>
      <td>{{ props.item.comm_name }}</td>
      <td>{{ props.item.total_report }}</td>
      <td>{{ props.item.is_submitted }}</td>
      <td>{{ props.item.is_approved }}</td>
    </tr>
  </template>
</v-data-table>
</div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="totRepHead"
      :items="totRepAppSub"
      title="Daily Report Details Based On Community"
      :subtitle="repDateFrom + ' - ' + repDateTo"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- total more than 9 working hours by community -->
<v-dialog v-model="showMorethan9WrkHrs" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showMorethan9WrkHrs = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="morethan9Head"
      :items="totMorethan9WorkHrs"
      fixed-header
      :height="totMorethan9WorkHrs.length > 5 ? '450' : totMorethan9WorkHrs.length * 100"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadMorethan9WrkHrsStaff(props.item)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.getMorethan9hrs }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="morethan9Head"
      :items="totMorethan9WorkHrs"
      title="OT > 9 Hours Based On Community"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- View morethan 9 working hours staff details -->
<v-dialog v-model="showMorethan9WrkHrsStaff" persistent scrollable max-width="800px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ this.moreThan9CommTitle + ' [' + this.moreThan9CommDate + ']'}}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showMorethan9WrkHrsStaff = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="moreThan9HrsStaffHead"
      :items="morethan9WrkHrsStaff"
      fixed-header
      height="450"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.staff_name }}</td>
          <td>{{ handy.formatDBDateTime(props.item.check_in) }}</td>
          <td>{{  handy.formatDBDateTime(props.item.check_out) }}</td>
          <td>{{ props.item.effective_work_hours }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="moreThan9HrsStaffHead"
      :items="morethan9WrkHrsStaff"
      title="OT > 9 Hours Staff Details"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- total more than 16 working hours by community -->
<v-dialog v-model="showMorethan16WrkHrs" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showMorethan16WrkHrs = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="morethan16Head"
      :items="totMorethan16WorkHrs"
      fixed-header
      :height="totMorethan16WorkHrs.length > 5 ? '450' : totMorethan16WorkHrs.length * 100"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadMorethan16WrkHrsStaff(props.item)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.getMorethan16hrs }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="morethan16Head"
      :items="totMorethan16WorkHrs"
      title="OT > 16 Hours Based On Community"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- View morethan 16 working hours staff details -->
<v-dialog v-model="showMorethan16WrkHrsStaff" persistent scrollable max-width="800px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ this.moreThan16CommTitle + ' [' + this.moreThan16CommDate + ']'}}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showMorethan16WrkHrsStaff = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="moreThan16HrsStaffHead"
      :items="morethan16WrkHrsStaff"
      fixed-header
      height="450"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.index + 1 }}</td>
          <td>{{ props.item.staff_name }}</td>
          <td>{{ handy.formatDBDateTime(props.item.check_in) }}</td>
          <td>{{  handy.formatDBDateTime(props.item.check_out) }}</td>
          <td>{{ props.item.effective_work_hours }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="moreThan16HrsStaffHead"
      :items="morethan16WrkHrsStaff"
      title="OT > 16 Hours Staff Details"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- total sla breached complaints by community -->
<v-dialog v-model="showSlaBreachComp" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showSlaBreachComp = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="slaBreachHead"
      :items="slaBreachCompByComm"
      fixed-header
      :height="slaBreachCompByComm.length > 5 ? '450' : slaBreachCompByComm.length * 100"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.tot_sla_comp }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="slaBreachHead"
      :items="slaBreachCompByComm"
      title="Sla Breached Complaints Based On Community"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- total stats of employee deployed/undeployed by community -->
<v-dialog v-model="showEmpDeployedAndUndepByComm" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showEmpDeployedAndUndepByComm = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="empDeployedHead"
      :items="empDeployedAndUndepByComm"
      fixed-header
      :height="empDeployedAndUndepByComm.length > 5 ? '450' : empDeployedAndUndepByComm.length * 100"
      :search="search"
      multi-sort
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadDeployedStaff(props.item)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.totdepUndep }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="empDeployedHead"
      :items="empDeployedAndUndepByComm"
      title="Deployed Staff Based On Community"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- View deployed staff details -->
<v-dialog v-model="showDeployedAndUndepStaff" persistent scrollable max-width="800px">
  <v-card>
    <v-flex xs12>
      <v-card-title class="title primary white--text pa-2">
        <div>
          {{ this.deployedStaffTitle + ' [' + this.deployedStaffDate + ']'}}
        </div>
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="showDeployedAndUndepStaff = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <div class="py-2 px-3 title grey lighten-3">Deployed Staff</div>
        <v-data-table
        :headers="deployedStaffHead"
        :items="deployedStaff"
        :search="search"
        hide-default-footer
        disable-pagination
        :mobile-breakpoint="0">
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.index + 1 }}</td>
            <td>{{ props.item.vendor_emp_id }}</td>
            <td>{{props.item.emp_name }}</td>
            <td>{{props.item.emp_desig }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </v-card-text>
  <v-card-actions class="grey lighten-4 caption">
    <v-layout>
      <v-flex xs6>
        <v-text-field
        append-icon="mdi-account-search"
        hide-details
        v-model="search"
        placeholder="Search"
        class="pa-2"
        clearable
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-download-as
        class="pt-3"
        :headers="deployedStaffHead"
        :items="deployedStaff"
        title="Deployed Staff Details"
        ></v-download-as>
      </v-flex>
    </v-layout>
  </v-card-actions>
</v-flex>
<v-divider></v-divider>
<v-flex xs12>
  <div class="py-2 px-3 title grey lighten-3">Undeployed Staff</div>
  <v-card-text class="pa-0">
    <v-data-table
    :headers="unDeployedStaffHead"
    :items="unDeployedStaff"
    :search="search"
    hide-default-footer
    disable-pagination
    :mobile-breakpoint="0">
    <template slot="item" slot-scope="props">
      <tr>
        <td>{{ props.index + 1 }}</td>
        <td>{{ props.item.vendor_emp_id }}</td>
        <td>{{props.item.emp_name }}</td>
        <td>{{props.item.emp_desig }}</td>
      </tr>
    </template>
  </v-data-table>
</div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="unDeployedStaffHead"
      :items="unDeployedStaff"
      title="Un Deployed Staff Details"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-flex>
</v-card>
</v-dialog>

<!-- community Drill down -->
<v-dialog v-model="showCommDrillDown" persistent scrollable max-width="1000px">
  <v-card flat>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      {{ selectedRole }} [Attendance Details]
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showCommDrillDown = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="attStaffHead"
      :items="communitiesListBasedOnRole"
      fixed-header
      height="450"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr  @click="loadAttDetBasedOnComm(props.item, selectedRole)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.present_per + '%' }}</td>
          <td>{{ props.item.absent_per + '%' }}</td>
          <td>{{ props.item.agreed_head_count }}</td>
          <td>{{ props.item.tot_deployed }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
  <v-card-actions class="grey lighten-4 caption">
    <v-layout>
      <v-flex xs6>
        <v-text-field
        append-icon="mdi-account-search"
        hide-details
        v-model="search"
        placeholder="Search"
        class="pa-2"
        clearable
        ></v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-download-as
        class="pa-2 mt-2"
        :headers="attHead"
        :items="commDrillDown[selectedRole]"
        title="Attendance Percentage Based On Community Wise"
        ></v-download-as>
      </v-flex>
    </v-layout>
  </v-card-actions>
</v-card>
</v-dialog>

<!-- total stats of last three days absentees by community -->
<v-dialog v-model="ShowlastThreeDaysAbsentCount" persistent scrollable max-width="900px">
  <v-card>
    <v-card-title class="title grey lighten-4 pa-2">
      <div>
        {{ zone.zone_name + ' [' + zone.date + ']' }}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="ShowlastThreeDaysAbsentCount = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="absenteesHead"
      :items="lastThreeDaysAbsentees"
      fixed-header
      :height="350"
      :search="search"
      multi-sort
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr @click="loadAbsenteesList(props.item)">
          <td>{{ props.item.comm_name }}</td>
          <td>{{ props.item.absentees }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="absenteesHead"
      :items="lastThreeDaysAbsentees"
      title="Last Three Days Absentees Based On Community"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- View absentees staff details -->
<v-dialog v-model="ShowAbsenteesList" persistent scrollable max-width="800px">
  <v-card>
    <v-card-title class="title primary--text grey lighten-4 pa-2">
      <div>
        {{ this.absenteesCommName + ' [' + this.absenteesDate + ']'}}
      </div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="ShowAbsenteesList = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
      :headers="absentessStaffHead"
      :items="absenteesList"
      fixed-header
      height="450"
      :search="search"
      hide-default-footer
      disable-pagination
      :mobile-breakpoint="0">
      <template slot="item" slot-scope="props">
        <tr>
          <td>{{ props.item.s_no }}</td>
          <td>{{ props.item.vendor_emp_id ? props.item.vendor_emp_id : '-' }}</td>
          <td>{{ props.item.staff_name ? props.item.staff_name : '-' }}</td>
          <td>{{ props.item.staff_role }}</td>
          <td>{{ props.item.from_dt }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</v-card-text>
<v-card-actions class="grey lighten-4 caption">
  <v-layout>
    <v-flex xs6>
      <v-text-field
      append-icon="mdi-account-search"
      hide-details
      v-model="search"
      placeholder="Search"
      class="pa-2"
      clearable
      ></v-text-field>
    </v-flex>
    <v-flex xs6>
      <v-download-as
      class="pt-3"
      :headers="absentessStaffHead"
      :items="absenteesList"
      title="Last Three Days Absentees List"
      ></v-download-as>
    </v-flex>
  </v-layout>
</v-card-actions>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

</v-col>
</v-row>
</v-container>
</template>

<script>
import VDownloadAs from './VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
var html2pdf = require('html2pdf.js')
var Chart = require('chart.js')
import 'chartjs-plugin-datalabels'

var COLORS = ['227,108,9', '49,133,155', '95,73,122', '118,146,60', '149,55,52', '54,96,146', '23,54,93', '73,68,41']

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      lAction: 'view',
      lDate: '',
      yesterdayDate: '',
      dlgDate: false,
      sbarMsg: '',
      sbar: false,
      handy: handy,
      config: config,
      rules: handy.rules,
      sbarCol: 'error',
      metrics: [],
      zones: [],
      header: [
        { text: 'Metric Name', value: 'name', sortable: false, class: 'primary white--text' },
        { text: 'Yesterday', value: 'zone_name', sortable: false, class: 'text-center', class: 'primary white--text' },
        { text: 'Today', value: 'zone_name', sortable: false, class: 'text-center', class: 'primary white--text' }
      ],
      attHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Attendnace %', value: 'percentage', class: 'primary white--text', sortable: false }
      ],
      attDetHead: [
        { text: 'Serial No', value: 'serial_no', class: 'primary white--text', sortable: false },
        { text: 'Staff Name', value: 'staff_name', class: 'primary white--text', sortable: false },
        { text: 'Staff Role', value: 'staff_role', class: 'primary white--text', sortable: false },
        { text: 'Shift', value: 'shift_abbr', class: 'primary white--text', sortable: false },
        { text: 'Start Time', value: 'start_time', class: 'primary white--text', sortable: false },
        { text: 'End Time', value: 'end_time', class: 'primary white--text', sortable: false },
        { text: 'Attendance', value: 'attendance', class: 'primary white--text', sortable: false },
        { text: 'Check_in', value: 'check_in', class: 'primary white--text', sortable: false },
        { text: 'Check_out', value: 'check_out', class: 'primary white--text', sortable: false },
        { text: 'Working Hours', value: 'work_hours', class: 'primary white--text', sortable: false },
        { text: 'Standby', value: 'emp_name', class: 'primary white--text', sortable: false }
      ],
      pendHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Pending In/Out', value: 'pendingInandOut', class: 'primary white--text', sortable: false }
      ],
      penDetHead: [
        { text: 'Serial No', value: 'serial_no', class: 'primary white--text', sortable: false },
        { text: 'Staff Name', value: 'staff_name', class: 'primary white--text', sortable: false },
        { text: 'Pending In/Out', value: 'penInOut', class: 'primary white--text', sortable: false }
      ],
      manualHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Manual In/Out', value: 'manualInandOut', class: 'primary white--text', sortable: false }
      ],
      manualDetHead: [
        { text: 'Serial No', value: 'serial_no', class: 'primary white--text', sortable: false },
        { text: 'Staff Name', value: 'staff_name', class: 'primary white--text', sortable: false },
        { text: 'Manual In/Out', value: 'manInOut', class: 'primary white--text', sortable: false }
      ],
      totRepHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Total Report', value: 'total_report', class: 'primary white--text', sortable: false },
        { text: 'Total Submitted', value: 'is_submitted', class: 'primary white--text', sortable: false },
        { text: 'Total Approved', value: 'is_approved', class: 'primary white--text', sortable: false }
      ],
      morethan9Head: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'OT > 9 Hours', value: 'getMorethan9hrs', class: 'primary white--text', sortable: false }
      ],
      moreThan9HrsStaffHead: [
        { text: 'Serial No', value: 'serial_no', class: 'primary white--text', sortable: false },
        { text: 'Staff Name', value: 'staff_name', class: 'primary white--text', sortable: false },
        { text: 'Check_in', value: 'check_in', class: 'primary white--text', sortable: false },
        { text: 'check_out', value: 'check_out', class: 'primary white--text', sortable: false },
        { text: 'Work Hours', value: 'effective_work_hours', class: 'primary white--text', sortable: false },
      ],
      morethan16Head: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'OT > 16 Hours', value: 'getMorethan16hrs', class: 'primary white--text', sortable: false }
      ],
      moreThan16HrsStaffHead: [
        { text: 'Serial No', value: 'serial_no', class: 'primary white--text', sortable: false },
        { text: 'Staff Name', value: 'staff_name', class: 'primary white--text', sortable: false },
        { text: 'Check_in', value: 'check_in', class: 'primary white--text', sortable: false },
        { text: 'check_out', value: 'check_out', class: 'primary white--text', sortable: false },
        { text: 'Work Hours', value: 'effective_work_hours', class: 'primary white--text', sortable: false },
      ],
      slaBreachHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Total Sla Breached Complaints', value: 'tot_sla_comp', class: 'primary white--text', sortable: false }
      ],
      empDeployedHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text' },
        { text: 'Total Employee Deployed/Undeployed', value: 'totdepUndep', class: 'primary white--text' }
      ],
      deployedStaffHead: [
        { text: 'Serial No', value: 'serial_no' },
        { text: 'Employee Id', value: 'vendor_emp_id'},
        { text: 'Staff Name', value: 'emp_name' },
        { text: 'Designation', value: 'emp_desig' }
      ],
      unDeployedStaffHead: [
        { text: 'Serial No', value: 'serial_no' },
        { text: 'Employee Id', value: 'vendor_emp_id' },
        { text: 'Staff Name', value: 'emp_name' },
        { text: 'Designation', value: 'emp_desig' }
      ],
      attStaffHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Present %', value: 'present_per', class: 'primary white--text', sortable: false },
        { text: 'Absent %', value: 'absent_per', class: 'primary white--text', sortable: false },
        { text: 'Agreed', value: 'agreed_head_count', class: 'primary white--text', sortable: false },
        { text: 'Deployed', value: 'tot_deployed', class: 'primary white--text', sortable: false }
      ],
      absenteesHead: [
        { text: 'Community Name', value: 'comm_name', class: 'primary white--text', sortable: false },
        { text: 'Absentees', value: 'absentees', class: 'primary white--text', sortable: false }
      ],
      absentessStaffHead: [
        { text: 'Serial No', value: 's_no', class: 'primary white--text', sortable: false },
        { text: 'Employee Id', value: 'vendor_emp_id', class: 'primary white--text', sortable: false },
        { text: 'Staff Name', value: 'staff_name', class: 'primary white--text', sortable: false },
        { text: 'Staff Role', value: 'staff_role', class: 'primary white--text', sortable: false },
        { text: 'Absent From', value: 'from_dt', class: 'primary white--text', sortable: false }
      ],
      attendance: [],
      pendingInAndOut: [],
      attDet: [],
      penDetComm: [],
      manualInAndOut: [],
      manualDetComm: [],
      totRepAppSub: [],
      totMorethan9WorkHrs: [],
      morethan9WrkHrsStaff: [],
      morethan16WrkHrsStaff: [],
      totMorethan16WorkHrs: [],
      slaBreachCompByComm: [],
      empDeployedAndUndepByComm: [],
      deployedStaff: [],
      unDeployedStaff: [],
      attCommTitle: '',
      attCommDate: '',
      penCommTitle: '',
      penCommDate: '',
      manCommTitle: '',
      manCommDate: '',
      moreThan9CommTitle: '',
      moreThan9CommDate: '',
      moreThan16CommTitle: '',
      moreThan16CommDate: '',
      deployedStaffTitle: '',
      deployedStaffDate: '',
      unDeployedStaffTitle: '',
      unDeployedStaffDate: '',
      showAttendance: false,
      showPendingInOut: false,
      showManualInOut: false,
      showAttDet: false,
      showPenDet: false,
      showManualDet: false,
      showTotRepAppSub: false,
      showMorethan9WrkHrs: false,
      showMorethan9WrkHrsStaff: false,
      showMorethan16WrkHrs: false,
      showMorethan16WrkHrsStaff: false,
      showSlaBreachComp: false,
      showEmpDeployedAndUndepByComm: false,
      showDeployedAndUndepStaff: false,
      dlgToDate: false,
      dlgFromDate: false,
      lField: {},
      roleList: ['HouseKeeper', 'Gardener', 'STP Operator', 'Electrician', 'Plumber'],
      staffRoleCount: {'HouseKeeper': [], 'Gardener': [], 'STP Operator': [], 'Electrician': [], 'Plumber': []},
      commDrillDown: [],
      showCommDrillDown: false,
      selectedRole: '',
      search: '',
      communitiesListBasedOnRole: [],
      lDateTo: null,
      lDateFrom: null,
      nodata: false,
      date: handy.formatDate(new Date()),
      lAttData: {},
      beforeYestDate: '',
      dayBeforeYest : '',
      twodayBeforeYest: '',
      lastThreeDaysAbsentees: [],
      ShowlastThreeDaysAbsentCount: false,
      absenteesList: [],
      ShowAbsenteesList: false,
      absenteesCommName: '',
      absenteesDate: '',
      zone: {},
      repToDate: false,
      repFromDate: false,
      repDateFrom: '',
      repDateTo: ''
    }
  },
  mounted () {
    var curDate = new Date()
    this.lDate = handy.formatDBDate(curDate)
    this.yesterdayDate = handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
    this.lDateFrom = this.lDateTo = this.lDate
    this.lField.percent = '80'
    this.lField.show_all_shifts = false
    if (config.ROLE_NAME === 'Field Officer') {
      this.loadFieldOffice(this.lDateFrom, this.lDateTo)
    } else {
      this.loadZones()
      this.lAction = 'view-operation-graph'
    }
  },
  created () {
    this.setTimer()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    setTimer () {
      // setTimeout(this.loadAllDateByZone(this.lDate), 600000)
      setInterval(() => this.loadAllDateByZone(this.lDate), 600000)
    },
    minPercentage () {
      if (this.lField.percent > 100) {
        this.msg('Please enter the percentage betweeen 0-100', 0)
      }
    },
    loadCommunityBasedOnMinPer (curRole, isAllShift) {
      this.selectedRole = curRole
      var fromTodates = []
      fromTodates.push(this.lDateFrom)
      fromTodates.push(this.lDateTo)
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          from_dt: fromTodates[0],
          to_dt: fromTodates[1],
          staff_role: curRole,
          minPercent: this.lField.percent
        }
      }
      var apiName = ''
      if (isAllShift === true) {
        apiName = '/getCommunityBasedOnminPerWithShift/'
      } else {
        apiName = '/getCommunityBasedOnminPer/'
      }
      this.axios.get(config.API_URL + apiName, qry)
      .then(response => {
        this.communitiesListBasedOnRole = response.data
        this.showCommDrillDown = true
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadAllDateByZonePieChart (curDate) {
      var date = new Date(curDate)
      this.lDate = curDate
      this.yesterdayDate = handy.formatDBDate(new Date(date.setDate(date.getDate() - 1)))
      this.zones.forEach(zone => {
        var qry = {
          params: {
            from_dt: this.yesterdayDate,
            to_dt: this.lDate,
            vendor_id: config.VENDOR_ID,
            zone_id: zone.zone_id,
            proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
          }
        }
        // use apiName based on head view or manager view
        var apiName = ''
        if (config.ROLE_NAME === 'Operations Manager') {
          apiName = '/getOperationManagerBasedOnZoneWisePieChart/'
        } else {
          apiName = '/getOperationHeadListBasedOnZoneWisePieChart/'
        }
        this.axios.get(config.API_URL + apiName, qry)
        .then(response => {
          // graph
          if (response.data.length && this.lAction === 'view-operation-graph' && (config.ROLE_NAME === 'Director' || config.ROLE_NAME === 'Administrator' || config.ROLE_NAME === 'Operations Manager')) {
            response.data.forEach(records => {
              if (records.length > 0) {
                records.forEach(rec => {
                  if (rec.metric_name === 'Attendance' && rec.zone_id === zone.zone_id && handy.formatDBDate(rec.att_dt) === this.lDate) {
                    var attData = []
                    attData.push(rec.present_per)
                    attData.push(rec.absent_per)
                    var totZero = 0
                    if (rec.tot_pend_in === totZero && rec.tot_pen_out === totZero) {
                      this.nodata = true
                    } else {
                      this.nodata = false
                    }
                    if (this.nodata) {
                      setTimeout(() => {
                        document.getElementById('div_attPer_today_' + zone.zone_id).innerHTML = 'No data available for today'
                      }, 500)
                      this.$forceUpdate()
                    } else {
                      document.getElementById('div_attPer_today_' + zone.zone_id).innerHTML = '<canvas id="chart_att_per_today_' + zone.zone_id + '"></canvas>'
                      var canvas = document.getElementById('chart_att_per_today_' + zone.zone_id)
                      var ctx = canvas.getContext('2d')
                      ctx.canvas.height = 200
                      ctx.canvas.width = 250
                      this.tmpChart = new Chart(ctx, {
                        type: 'polarArea',
                        data: {
                          labels: ['Present', 'Absent'],
                          datasets: [{
                            backgroundColor: ['#008000', '#FF0000'],
                            data: attData
                          }]
                        },
                        options: {
                          plugins: {
                            datalabels: {
                              formatter: function (value) {
                                return value > 0 ? value + ' %' : ''
                              },
                              color: '#ffffff'
                            }
                          },
                          title: {
                            display: true,
                            text: 'Today'
                          },
                          legend: {
                            position: 'bottom'
                          }
                        }
                      })
                    }
                  }
                  if (rec.metric_name === 'Attendance' && rec.zone_id === zone.zone_id && handy.formatDBDate(rec.att_dt) === this.yesterdayDate) {
                    var attData = []
                    attData.push(rec.present_per)
                    attData.push(rec.absent_per)
                    var totZero = 0
                    if (rec.tot_pend_in === totZero && rec.tot_pen_out === totZero) {
                      this.nodata = true
                    } else {
                      this.nodata = false
                    }
                    if (this.nodata) {
                      setTimeout(() => {
                        document.getElementById('div_attPer_yest_' + zone.zone_id).innerHTML = 'No data available for yesterday'
                      }, 500)
                      this.$forceUpdate()
                    } else {
                      document.getElementById('div_attPer_yest_' + zone.zone_id).innerHTML = '<canvas id="chart_att_per_yest_' + zone.zone_id + '"></canvas>'
                      var canvas = document.getElementById('chart_att_per_yest_' + zone.zone_id)
                      var ctx = canvas.getContext('2d')
                      ctx.canvas.height = 200
                      ctx.canvas.width = 250
                      this.tmpChart = new Chart(ctx, {
                        type: 'polarArea',
                        data: {
                          labels: ['Present', 'Absent'],
                          datasets: [{
                            backgroundColor: ['#008000', '#FF0000'],
                            data: attData
                          }]
                        },
                        options: {
                          plugins: {
                            datalabels: {
                              formatter: function (value) {
                                return value > 0 ? value + ' %' : ''
                              },
                              color: '#ffffff'
                            }
                          },
                          title: {
                            display: true,
                            text: 'Yesterday'
                          },
                          legend: {
                            position: 'bottom'
                          }
                        }
                      })
                    }
                  }
                  if (rec.metric_name === 'Pending In/Out' && rec.zone_id === zone.zone_id && handy.formatDBDate(rec.att_dt) === this.lDate) {
                    var pendingData = []
                    pendingData.push(rec.tot_pend_in)
                    pendingData.push(rec.tot_pen_out)
                    var totZero = 0
                    if (rec.tot_pend_in === totZero && rec.tot_pen_out === totZero) {
                      this.nodata = true
                    } else {
                      this.nodata = false
                    }
                    if (this.nodata) {
                      setTimeout(() => {
                        document.getElementById('div_pend_today_' + zone.zone_id).innerHTML = 'Pending In/Out for Today is "0"'
                      }, 500)
                      this.$forceUpdate()
                    } else {
                      document.getElementById('div_pend_today_' + zone.zone_id).innerHTML = '<canvas id="chart_pend_today_' + zone.zone_id + '"></canvas>'
                      var canvas = document.getElementById('chart_pend_today_' + zone.zone_id)
                      var ctx = canvas.getContext('2d')
                      ctx.canvas.height = 200
                      ctx.canvas.width = 250
                      this.tmpChart = new Chart(ctx, {
                        type: 'polarArea',
                        data: {
                          labels: ['Pend. In','Pend. Out'],
                          datasets: [{
                            backgroundColor: ['#5f497a', '#76923c'],
                            data: pendingData
                          }]
                        },
                        options: {
                          plugins: {
                            datalabels: {
                              formatter: function (value) {
                                return value > 0 ? value : ''
                              },
                              color: '#ffffff'
                            }
                          },
                          title: {
                            display: true,
                            text: 'Today'
                          },
                          legend: {
                            position: 'bottom'
                          }
                        }
                      })
                    }
                  }
                  if (rec.metric_name === 'Pending In/Out' && rec.zone_id === zone.zone_id && handy.formatDBDate(rec.att_dt) === this.yesterdayDate) {
                    var pendingData = []
                    pendingData.push(rec.tot_pend_in)
                    pendingData.push(rec.tot_pen_out)
                    var totZero = 0
                    if (rec.tot_pend_in === totZero && rec.tot_pen_out === totZero) {
                      this.nodata = true
                    } else {
                      this.nodata = false
                    }
                    if (this.nodata) {
                      setTimeout(() => {
                        document.getElementById('div_pend_yest_' + zone.zone_id).innerHTML = 'Pending In/Out for Yesterday is "0"'
                      }, 500)
                      this.$forceUpdate()
                    } else {
                      document.getElementById('div_pend_yest_' + zone.zone_id).innerHTML = '<canvas id="chart_pend_yest_' + zone.zone_id + '"></canvas>'
                      var canvas = document.getElementById('chart_pend_yest_' + zone.zone_id)
                      var ctx = canvas.getContext('2d')
                      ctx.canvas.height = 200
                      ctx.canvas.width = 250
                      this.tmpChart = new Chart(ctx, {
                        type: 'polarArea',
                        data: {
                          labels: ['Pend. In','Pend. Out'],
                          datasets: [{
                            backgroundColor: ['#5f497a', '#76923c'],
                            data: pendingData
                          }]
                        },
                        options: {
                          plugins: {
                            datalabels: {
                              formatter: function (value) {
                                return value > 0 ? value : ''
                              },
                              color: '#ffffff'
                            }
                          },
                          title: {
                            display: true,
                            text: 'Yesterday'
                          },
                          legend: {
                            position: 'bottom'
                          }
                        }
                      })
                    }
                  }
                })
              }
            })
          }
        })
        .catch(err => {
          this.msg(err, 0)
        })
      })
    },
    loadAllDateByZone (curDate) {
      var date = new Date(curDate)
      this.lDate = curDate
      this.yesterdayDate = handy.formatDBDate(new Date(date.setDate(date.getDate() - 1)))
      this.beforeYestDate =  handy.formatDBDate(new Date(date.setDate(date.getDate() - 1)))
      this.dayBeforeYest =  handy.formatDBDate(new Date(date.setDate(date.getDate() - 1)))
      this.twodayBeforeYest =  handy.formatDBDate(new Date(date.setDate(date.getDate() - 1)))
      var yestDates = []
      yestDates.push(this.twodayBeforeYest)
      yestDates.push(this.dayBeforeYest)
      yestDates.push(this.beforeYestDate)
      var todayDates = []
      todayDates.push(this.dayBeforeYest)
      todayDates.push(this.beforeYestDate)
      todayDates.push(this.yesterdayDate)
      this.metrics = []
      this.zones.forEach(zone => {
        var qry = {
          params: {
            from_dt: this.yesterdayDate,
            to_dt: this.lDate,
            vendor_id: config.VENDOR_ID,
            zone_id: zone.zone_id,
            proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null,
            dayBeforeYest: yestDates,
            todayBackDates: todayDates
          }
        }
        // use apiName based on head view or manager view
        var apiName = ''
        if (config.ROLE_NAME === 'Operations Manager') {
          apiName = '/getOperationManagerBasedOnZone/'
        } else {
          apiName = '/getOperationHeadListBasedOnZone/'
        }
        this.axios.get(config.API_URL + apiName, qry)
        .then(response => {
          for (var i = 0; i < response.data.length - 1; i++) {
            var rec = response.data[i]
            var att = []
            var metric = rec.map(met => met.metric_name)[0]
            rec.forEach(records => {
              if (records.metric_name === 'Attendance' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.present_per + '%',
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              } else if (records.metric_name === 'Pending In/Out' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.tot_pend_in + '/' + records.tot_pen_out,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              } else if (records.metric_name === 'Manual In/Out' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.manual_in + '/' + records.manual_out,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              } else if (records.metric_name === 'OT > 9 Hours' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.getMorethan9hrs,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              } else if (records.metric_name === 'OT > 16 Hours' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.getMorethan16hrs,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              } else if (records.metric_name === 'Last three days absentees' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.absentees,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              } else if (records.metric_name === 'Daily Report Approved/Submitted/Total' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.is_approved + '/' + records.is_submitted + '/' + records.total_report,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              } else if (records.metric_name === 'Employees Deployed/Undeployed' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.deployed + '/' + records.un_deployed,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              }  else if (records.metric_name === 'Total SLA Breached Complaints' && records.zone_id === zone.zone_id) {
                att.push({
                  value: records.tot_sla_comp,
                  zone_id: records.zone_id,
                  date: records.att_dt,
                  zone_name: records.zone_name
                })
              }
            })
            if (att.length === 2) {
              this.metrics.push({
                zone_id: zone.zone_id,
                name: metric,
                values: att
              })
            }
          }
        })
        .catch(err => {
          this.msg(err, 0)
        })
      })
    },
    loadZones () {
      var curdate = handy.formatDBDate(new Date())
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getZones/', qry)
      .then(response => {
        this.zones = response.data
        if (this.lAction === 'view-operation-graph') {
          this.loadAllDateByZonePieChart(this.lDate)
        } else {
          this.loadAllDateByZone(this.lDate)
        }
      })
      .catch(err => {
        this.msg(err.response.data)
        this.zones = []
      })
    },
    loadAllCommDetailsBasedOnZone (curName, curZoneValue) {
      this.zone = {
        att_dt: handy.formatDBDate(curZoneValue.date),
        zone_id: curZoneValue.zone_id,
        date: handy.formatDate(curZoneValue.date),
        zone_name: curZoneValue.zone_name
      }
      if (curName === 'Attendance') {
        this.loadAttByCommBasedOnZone(curZoneValue)
      } else if (curName === 'Pending In/Out') {
        this.loadPendingInOutByCommBasedOnZone (curZoneValue)
      } else if (curName === 'Manual In/Out') {
        this.loadManualInOutByCommBasedOnZone (curZoneValue)
      } else if (curName === 'Daily Report Approved/Submitted/Total') {
        this.loadTotRepAppSubByCommBasedOnZone (curZoneValue, curName)
      } else if (curName === 'OT > 9 Hours') {
        this.loadStatsofMoreThan9WorkHoursByCommBasedOnZone (curZoneValue)
      } else if (curName === 'OT > 16 Hours') {
        this.loadStatsofMoreThan16WorkHoursByCommBasedOnZone (curZoneValue)
      } else if (curName === 'Total SLA Breached Complaints') {
        this.loadStatsOfSlaBreachedCompBasedOnComm (curZoneValue)
      } else if (curName === 'Employees Deployed/Undeployed') {
        this.loadStatsOfEmpDeployedAndDeployedBasedOnComm (curZoneValue)
      } else if (curName === 'Last three days absentees') {
        this.loadLastThreeDaysAbsenteesByComm (curZoneValue)
      }
    },
    loadAttByCommBasedOnZone (curZoneValue) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: handy.formatDBDate(curZoneValue.date),
          zone_id: curZoneValue.zone_id,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getAttendanceBasedOnzone/', qry)
      .then(response => {
        this.attendance = response.data
        if (response.data.length) {
          response.data.forEach(rec => {
            rec.percentage = (rec.total_present ? Math.round((rec.total_present / rec.tot_deployed) * 100) : '0') + '%'
          })
        }
        this.lAttData = {
          comm_id: null,
          comm_name: '',
          att_dt: null,
          showAllShifts: 'Shift'
        }
        this.showAttendance = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.attendance = []
      })
    },
    loadAllShift (curComm, curRole=null, isAllShift) {
      this.attDet = []
      this.loadAttDetBasedOnComm (curComm, curRole, isAllShift)
    },
    loadAttDetBasedOnComm (curComm, curRole=null, isAllShift = 'Shift') {
      this.lAttData.showAllShifts = isAllShift
      if (curComm.comm_id) {
        this.lAttData.comm_id = curComm.comm_id
      }
      if (curComm.att_dt) {
        this.lAttData.att_dt = curComm.att_dt
      }
      if (curComm.comm_name) {
        this.lAttData.comm_name = curComm.comm_name
      }
      var fromDate = null
      var toDate = null
      if (curComm.att_dt) {
        fromDate = toDate = curComm.att_dt
      } else {
        fromDate = this.lDateFrom
        toDate = this.lDateTo
      }
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          from_dt: handy.formatDBDate(fromDate),
          to_dt: handy.formatDBDate(toDate),
          vendor_id: config.VENDOR_ID,
          role: curRole,
          isAllShift: isAllShift
        }
      }
      this.attDet = []
      this.axios.get(config.API_URL + '/getAttDetBasedOnComm/', qry)
      .then(response => {
        if (response.data.length) {
          this.attDet = response.data
        }
        this.attCommTitle = curComm.comm_name
        if (curComm.att_dt) {
          this.attCommDate = handy.formatDate(curComm.att_dt)
        } else {
          this.attCommDate = null
        }
        this.showAttDet = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.attDet = []
      })
    },
    CloseAtt () {
      this.showAttDet = false
      this.lAttData.showAllShifts = false
    },
    loadPendingInOutByCommBasedOnZone (curZoneValue) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: handy.formatDBDate(curZoneValue.date),
          zone_id: curZoneValue.zone_id,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfPendingInOut/', qry)
      .then(response => {
        this.pendingInAndOut = response.data
        if (response.data.length) {
          response.data.forEach(rec => {
            rec.pendingInandOut = rec.tot_pend_in + ' | ' + rec.tot_pen_out
          })
        }
        this.showPendingInOut = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.pendingInAndOut = []
      })
    },
    loadPenByComm (curComm) {
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          att_dt: handy.formatDBDate(curComm.att_dt),
          vendor_id: config.VENDOR_ID
        }
      }
      this.penDetComm = []
      this.axios.get(config.API_URL + '/getPendingInOutByComm/', qry)
      .then(response => {
        if (response.data.length) {
          for(var i=0; i < response.data.length; i++) {
            this.penDetComm.push({
              staff_name: response.data[i].staff_name,
              penInOut: response.data[i].tot_pend_in + ' | ' + response.data[i].tot_pen_out
            })
          }
        }
        this.penCommTitle = curComm.comm_name
        this.penCommDate = handy.formatDate(curComm.att_dt)
        this.showPenDet = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.penDetComm = []
      })
    },
    loadManualInOutByCommBasedOnZone (curZoneValue) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: handy.formatDBDate(curZoneValue.date),
          zone_id: curZoneValue.zone_id,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getManualAttendance/', qry)
      .then(response => {
        this.manualInAndOut = response.data
        if (response.data.length) {
          response.data.forEach(rec => {
            rec.manualInandOut = rec.manual_in + ' | ' + rec.manual_out
          })
        }
        this.showManualInOut = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.manualInAndOut = []
      })
    },
    loadManualByComm (curComm) {
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          att_dt: handy.formatDBDate(curComm.att_dt),
          vendor_id: config.VENDOR_ID
        }
      }
      this.manualDetComm = []
      this.axios.get(config.API_URL + '/getManualInOutByComm/', qry)
      .then(response => {
        if (response.data.length) {
          for(var i=0; i < response.data.length; i++) {
            this.manualDetComm.push({
              staff_name: response.data[i].staff_name,
              manInOut: response.data[i].manual_in + ' | ' + response.data[i].manual_out
            })
          }
        }
        this.manCommTitle = curComm.comm_name
        this.manCommDate = handy.formatDate(curComm.att_dt)
        this.showManualDet = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.penDetComm = []
      })
    },
    loadTotRepAppSubByCommBasedOnZone (curZoneValue, curName=null, rep_from_dt=null, rep_to_dt=null) {
      var date = null
      if (curName!=null) {
        this.repDateFrom = handy.formatDBDate(curZoneValue.date)
        this.repDateTo = handy.formatDBDate(curZoneValue.date)
        date = handy.formatDBDate(curZoneValue.date)
      } else {
        this.repDateFrom = rep_from_dt
        this.repDateTo = rep_to_dt
        date = curZoneValue.att_dt
      }
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: date,
          zone_id: curZoneValue.zone_id,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null,
          from_dt: this.repDateFrom,
          to_dt: this.repDateTo
        }
      }
      this.axios.get(config.API_URL + '/getAppsubDailyReport/', qry)
      .then(response => {
        this.totRepAppSub = response.data
        this.showTotRepAppSub = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.totRepAppSub = []
      })
    },
    loadStatsofMoreThan9WorkHoursByCommBasedOnZone (curZoneValue) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: handy.formatDBDate(curZoneValue.date),
          zone_id: curZoneValue.zone_id,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfMorethan9WorkHours/', qry)
      .then(response => {
        this.totMorethan9WorkHrs = response.data
        this.showMorethan9WrkHrs = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.totMorethan9WorkHrs = []
      })
    },
    loadMorethan9WrkHrsStaff (curComm) {
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          att_dt: handy.formatDBDate(curComm.att_dt),
          vendor_id: config.VENDOR_ID
        }
      }
      this.morethan9WrkHrsStaff = []
      this.axios.get(config.API_URL + '/getMoreThan9WrkHrsStaffBycomm/', qry)
      .then(response => {
        if (response.data.length) {
          this.morethan9WrkHrsStaff = response.data
        }
        this.moreThan9CommTitle = curComm.comm_name
        this.moreThan9CommDate = handy.formatDate(curComm.att_dt)
        this.showMorethan9WrkHrsStaff = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.morethan9WrkHrsStaff = []
      })
    },
    loadStatsofMoreThan16WorkHoursByCommBasedOnZone (curZoneValue) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          att_dt: handy.formatDBDate(curZoneValue.date),
          zone_id: curZoneValue.zone_id,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfMorethan16WorkHours/', qry)
      .then(response => {
        this.totMorethan16WorkHrs = response.data
        this.showMorethan16WrkHrs = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.totMorethan16WorkHrs = []
      })
    },
    loadMorethan16WrkHrsStaff (curComm) {
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          att_dt: handy.formatDBDate(curComm.att_dt),
          vendor_id: config.VENDOR_ID
        }
      }
      this.morethan16WrkHrsStaff = []
      this.axios.get(config.API_URL + '/getMoreThan16WrkHrsStaffBycomm/', qry)
      .then(response => {
        if (response.data.length) {
          this.morethan16WrkHrsStaff = response.data
        }
        this.moreThan16CommTitle = curComm.comm_name
        this.moreThan16CommDate = handy.formatDate(curComm.att_dt)
        this.showMorethan16WrkHrsStaff = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.morethan16WrkHrsStaff = []
      })
    },
    loadStatsOfSlaBreachedCompBasedOnComm (curZoneValue) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          zone_id: curZoneValue.zone_id,
          att_dt: handy.formatDBDate(curZoneValue.date),
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfSlaBreachedComp/', qry)
      .then(response => {
        this.slaBreachCompByComm = response.data
        this.showSlaBreachComp = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.slaBreachCompByComm = []
      })
    },
    loadStatsOfEmpDeployedAndDeployedBasedOnComm (curZoneValue) {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          zone_id: curZoneValue.zone_id,
          att_dt: handy.formatDBDate(curZoneValue.date),
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getStatsOfEmployeeDeployedandUndeployed/', qry)
      .then(response => {
        this.empDeployedAndUndepByComm = response.data
        if (response.data.length) {
          response.data.forEach(rec => {
            rec.totdepUndep = rec.deployed + ' | ' + rec.un_deployed
          })
        }
        this.showEmpDeployedAndUndepByComm = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.empDeployedAndUndepByComm = []
      })
    },
    loadDeployedStaff (curComm) {
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          deployed_on: curComm.att_dt,
          vendor_id: config.VENDOR_ID,
          type: 'deployed'
        }
      }
      this.deployedStaff = []
      this.axios.get(config.API_URL + '/getdeployedStaffBasedOnProj/', qry)
      .then(response => {
        if (response.data.length) {
          this.deployedStaff = response.data
        }
        this.loadUnDeployedStaff(curComm)
        this.deployedStaffTitle = curComm.comm_name
        this.deployedStaffDate = handy.formatDate(curComm.att_dt)
        this.showDeployedAndUndepStaff = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.deployedStaff = []
      })
    },
    loadUnDeployedStaff (curComm) {
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          undeployed_on: curComm.att_dt,
          vendor_id: config.VENDOR_ID,
          type: 'undeployed'
        }
      }
      this.unDeployedStaff = []
      this.axios.get(config.API_URL + '/getdeployedStaffBasedOnProj/', qry)
      .then(response => {
        if (response.data.length) {
          this.unDeployedStaff = response.data
        }
        this.unDeployedStaffTitle = curComm.comm_name
        this.unDeployedStaffDate = handy.formatDate(curComm.att_dt)
      })
      .catch(err => {
        this.msg(err, 0)
        this.unDeployedStaff = []
      })
    },
    loadLastThreeDaysAbsenteesByComm (curZoneValue) {
      var curDate = new Date(curZoneValue.date)
      this.yesterdayDate = handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      this.beforeYestDate =  handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      this.dayBeforeYest =  handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      var yestDates = []
      yestDates.push(this.dayBeforeYest)
      yestDates.push(this.beforeYestDate)
      yestDates.push(this.yesterdayDate)
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          zone_id: curZoneValue.zone_id,
          att_dt: handy.formatDBDate(curZoneValue.date),
          todayBackDates: yestDates,
          proj_manager: config.ROLE_NAME === 'Operations Manager' ? config.EMP_ID : null
        }
      }
      this.axios.get(config.API_URL + '/getCountOfLastthreeDaysTodayAbsenteesByComm/', qry)
      .then(response => {
        this.lastThreeDaysAbsentees = response.data
        this.ShowlastThreeDaysAbsentCount = true
      })
      .catch(err => {
        this.msg(err, 0)
        this.lastThreeDaysAbsentees = []
      })
    },
    loadAbsenteesList (curComm) {
      var curDate = new Date(curComm.att_dt)
      this.yesterdayDate = handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      this.beforeYestDate =  handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      this.dayBeforeYest =  handy.formatDBDate(new Date(curDate.setDate(curDate.getDate() - 1)))
      var yestDates = []
      yestDates.push(this.dayBeforeYest)
      yestDates.push(this.beforeYestDate)
      yestDates.push(this.yesterdayDate)
      var qry = {
        params: {
          comm_id: curComm.comm_id,
          att_dt: handy.formatDBDate(curComm.att_dt),
          vendor_id: config.VENDOR_ID,
          todayBackDates: yestDates
        }
      }
      this.absenteesList = []
      this.axios.get(config.API_URL + '/getLastThreeDaysAbsenteesStaffList/', qry)
      .then(response => {
        if (response.data.length) {
          for(var i = 0; i < response.data.length; i++) {
            this.absenteesList.push({
              s_no: i+1,
              staff_name: response.data[i].staff_name,
              vendor_emp_id: response.data[i].vendor_emp_id,
              staff_role: response.data[i].staff_role,
              from_dt: response.data[i].from_dt
            })
          }
        }
        this.ShowAbsenteesList = true
        this.absenteesCommName = curComm.comm_name
        this.absenteesDate = handy.formatDate(curComm.att_dt)
      })
      .catch(err => {
        this.msg(err, 0)
        this.absenteesList = []
      })
    },
    loadFieldOffice (fromDate, toDate, isAllShift) {
      var fromTodates = []
      fromTodates.push(fromDate)
      fromTodates.push(toDate)
      this.roleList.forEach(rec => {
        this.loadstaffRoleCount(fromTodates, rec, isAllShift)
      })
    },
    loadstaffRoleCount (curDates, curRole, isAllShift = false) {
      var qry = {
        params: {
          att_dt: curDates,
          vendor_id: config.VENDOR_ID,
          staff_role: curRole,
          minPercent: this.lField.percent
        }
      }
      this.staffRoleCount[curRole] = {
        present_percent: 0,
        absent_percent: 0,
        total_absent: 0,
        total_community: 0
      }
      var apiName = ''
      if (isAllShift === true) {
        apiName = '/getRolewisePercentWithShift/'
      } else {
        apiName = '/getRolewisePercent/'
      }
      this.axios.get(config.API_URL + apiName, qry)
      .then(response => {
        if (response.data) {
          // first result set from SP
          if(curRole === response.data[0][0].staff_role) {
            this.staffRoleCount[curRole].total_absent = response.data[0][0].tot_absent
            this.staffRoleCount[curRole].total_community = response.data[0][0].tot_comm
          }
          // second result set from SP
          if(curRole === response.data[1][0].staff_role) {
            this.staffRoleCount[curRole].present_percent = Math.round(response.data[1][0].avg_present_per)
            this.staffRoleCount[curRole].absent_percent = Math.round(response.data[1][0].avg_absent_per)
          }
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    downloadAsPdf () {
      // pdf options
      let opt = {
        margin: 15,
        filename: 'All Zone Details' + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { orientation: 'landscape', scrollX: 0, scrollY: 0, width: 596 },
        pagebreak: { before: '#pageBreak' }
      }
      var canvas = document.getElementById('pdf_report')
      html2pdf(canvas, opt)
    },
    loadTableView () {
      this.lAction = 'view-operation'
      this.loadZones()
    },
    goBack () {
      this.lAction = 'view-operation-graph'
      this.loadZones()
    }
  }
}
</script>
